import * as http from './http';

export function sendPush(target: string, text:string) {
  return http.post('/api/v1/admin/push/send', {
    target,
    text
  });
}
